<template>
  <abbr v-if="value >= NUMBER_FORMAT_LIMIT" :title="value">
    {{ StringUtils.metricsNumberFormat(value) }}
  </abbr>
  <span v-else> {{ `${value}`.toLocaleString() }} </span>
</template>

<script setup>
import StringUtils from "@/utils/StringUtils";

defineProps(["value"]);
const NUMBER_FORMAT_LIMIT = 1000;
</script>
